import { Home, Search, Share2, Clock, Star, Pin, Trash2, CalendarClock, FileSignature, KeyRound, BarChart3, Network, ShieldCheck, ListOrdered, Users, HardDrive, Settings } from 'lucide-react';
import { P } from '../utils/permissions';

/**
 * v2 navigation model.
 *
 * Main nav is short by design; departments are the primary way into documents and are
 * appended at runtime from GET /api/departments — never hard-coded. The Administration
 * group renders only for users holding at least one admin permission, and each item is
 * filtered by its own permission (UX Rule 3).
 */
export const MAIN_NAV = [
  { key: 'home', label: 'Home', to: '/dashboard', icon: Home, end: true },
  { key: 'search', label: 'Search', to: '/search', icon: Search },
  { key: 'shared', label: 'Shared with me', to: '/shared', icon: Share2 },
  { key: 'recent', label: 'Recent', to: '/recent', icon: Clock },
  { key: 'favorites', label: 'Favourites', to: '/favorites', icon: Star },
  // Beside Favourites, because the two answer adjacent questions and the difference is worth
  // seeing: Favourites is what I chose to keep handy, Pinned is what the company says matters.
  { key: 'pinned', label: 'Pinned', to: '/pinned', icon: Pin },
  // Above Trash rather than buried under Administration: the people who chase a licence
  // renewal are rarely administrators, and a compliance page nobody can find is decorative.
  // Above Renewals because it is a queue rather than a watch-list: somebody is waiting on
  // the reader personally. 'badge' names the count the sidebar fetches for it.
  { key: 'signatures', label: 'To sign', to: '/signatures', icon: FileSignature, badge: 'toSign' },
  { key: 'renewals', label: 'Renewals', to: '/renewals', icon: CalendarClock },
  // No permission: this replaces sending a password over WhatsApp, and a feature only some
  // people may use is one the rest go around.
  { key: 'secrets', label: 'Send a secret', to: '/secrets', icon: KeyRound },
  { key: 'trash', label: 'Trash', to: '/trash', icon: Trash2 },
];

export const ADMIN_NAV = [
  { key: 'admin', label: 'Overview', to: '/admin', icon: BarChart3, end: true, permission: P.ADMIN_STORAGE_VIEW },
  { key: 'depts', label: 'Departments', to: '/admin/departments', icon: Network, permission: P.ADMIN_DEPARTMENT_MANAGE },
  { key: 'users', label: 'Users', to: '/admin/users', icon: Users, permission: P.ADMIN_USER_MANAGE },
  { key: 'roles', label: 'Roles & permissions', to: '/admin/roles', icon: ShieldCheck, permission: P.ADMIN_ROLE_MANAGE },
  { key: 'audit', label: 'Audit trail', to: '/admin/audit', icon: ListOrdered, permission: P.ADMIN_AUDIT_VIEW },
  { key: 'storage', label: 'Storage', to: '/admin/storage', icon: HardDrive, permission: P.ADMIN_STORAGE_VIEW },
  { key: 'system', label: 'System settings', to: '/admin/settings', icon: Settings, permission: P.ADMIN_SETTINGS_MANAGE },
];

export const ADMIN_PERMISSIONS = ADMIN_NAV.map((i) => i.permission);
